import { sanitizeObject, sanitizeString } from '../security/sensitiveDataSanitizer';
import type { BreadcrumbEntry, BreadcrumbType } from '../types/error.types';
import { nowIso } from '../utils/time';

const MAX_BREADCRUMBS = 50;
const breadcrumbs: BreadcrumbEntry[] = [];

function normalizeType(type: string | undefined): BreadcrumbType {
  switch (type) {
    case 'navigation':
    case 'click':
    case 'api':
    case 'error':
    case 'user_action':
    case 'form':
    case 'system':
      return type;
    default:
      return 'system';
  }
}

export function addBreadcrumb(input: {
  type?: BreadcrumbType;
  message: string;
  route?: string;
  timestamp?: string;
  metadata?: Record<string, unknown>;
}): void {
  breadcrumbs.push({
    type: normalizeType(input.type),
    message: sanitizeString(input.message),
    route: input.route ? sanitizeString(input.route) : undefined,
    timestamp: input.timestamp ?? nowIso(),
    metadata: input.metadata ? sanitizeObject(input.metadata) : undefined,
  });

  if (breadcrumbs.length > MAX_BREADCRUMBS) {
    breadcrumbs.splice(0, breadcrumbs.length - MAX_BREADCRUMBS);
  }
}

export function getBreadcrumbs(): BreadcrumbEntry[] {
  return [...breadcrumbs];
}

export function clearBreadcrumbs(): void {
  breadcrumbs.length = 0;
}
